import React, { useState } from 'react'
import StepWhySokooni from './steps/StepWhySokooni'
import StepAccountRegistration from './steps/StepAccountRegistration'
import { useLocation, useNavigate } from 'react-router-dom'
import Stepper from '../../components/common/Stepper'
import BackIcon from '../../components/icons/BackIcon'
import StepAccountVerification from './steps/StepAccountVerification'

const steps = [StepWhySokooni, StepAccountVerification, StepAccountRegistration]

const SignupStepper = ({ userType }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [step, setStep] = useState(location.state?.startStep || 0)
  const [signupData, setSignupData] = useState({
    role: userType,
    phone: location.state?.phoneNumber,
  })

  const CurrentStep = steps[step]

  const handleNext = (data, moveNextStep = true) => {
    setSignupData((prev) => ({ ...prev, ...data }))

    if (!moveNextStep) return

    setStep((prev) => prev + 1)
  }

  const handleBack = () => {
    if (step === 0) {
      // navigate back if a previous url is available else navigate to home
      if (window.history.length > 1) {
        navigate(-1)
        return
      }
      navigate('/')
      return
    }

    setStep((prev) => prev - 1)
  }

  return (
    <div className="flex flex-col  bg-background-secondary">
      <div className="w-full max-w-md mx-auto min-h-screen bg-background shadow-lg rounded-xl overflow-hidden">
        <div className="flex items-center justify-between p-4 main-container">
          <button
            className="flex items-center justify-center bg-background border border-gray-200 rounded-full w-10 h-10 shadow-sm hover:bg-neutral-200-50 transition-colors duration-200"
            onClick={handleBack}
            aria-label="Back"
          >
            <BackIcon />
          </button>
        </div>

        <div className="main-container">
          <Stepper currentStep={step} />
        </div>

        <div className="main-container">
          <CurrentStep
            data={signupData}
            onNext={handleNext}
            onBack={handleBack}
            userType={userType}
          />
        </div>
      </div>
    </div>
  )
}

export default SignupStepper
